module.exports = __webpack_public_path__ + "pc/img/swiper_logo_04.bfe3329b.png";